import styled from 'styled-components';

export const SelectStyle = styled.select`
  box-sizing: border-box;
  padding: 10px;
  border-radius: ${({ theme }) => {
    return theme.borderRadius.small;
  }};
  border: ${({ theme }) => {
    return theme.border;
  }};

  font-family: 'Ubuntu', sans-serif;
  font-size: ${({ theme }) => {
    return theme.fonts.size.small;
  }};
`;
